import { api } from '..'

export const deleteAlertRuleFromDevice =
  (deviceId: string, alertRuleId: string) => () =>
    api.delete(`/v1/devices/${deviceId}/alert-rules/${alertRuleId}`)

export const deleteDeviceFromAlertRule =
  (alertRuleId: string, deviceId: string) => () =>
    api.delete(`/v1/alert-rules/${alertRuleId}/devices/${deviceId}`)
